<template>
  <div>
    <div class="dovemed-card">
      <h3 :style="{ 'text-align': 'left', 'margin-top': '24px', 'font-size': '32px', 'font-weight': '700', 'font-family': 'Lato', color: '#0F1734' }">Recommendations</h3>
      <div class="search-container w-100">
        <form @submit.prevent="" class="w-100 d-flex align-items-center searchContainer">
          <input type="search" class="search-input-state w-100" placeholder="Search by name" v-model="searchbyname" @input="callDebounce" @keyup.enter="handleSearchEnter" />
          <a-icon v-if="searchbyname" class="close-icon cp" style="width: fit-content" type="close" :size="'large'" @click="handleClearSearch" />
        </form>
        <button @click="handlefilter" class="search-button primary-button position-relative">
          <img src="../../../assets/lightfilter.svg" alt="filter icon" />
          <p class="apply">Apply Filters</p>
          <div v-if="role !== undefined" class="active-filter-indicator" :style="{ background: getPrimaryColor() }" />
        </button>
      </div>
      <div v-if="role !== undefined" class="top_filters">
        <div class="filter-container">
          <div class="appliedFilter">Applied Filter:</div>
          <div v-if="role !== undefined" class="filterTypeBox">
            <div class="filterTypeText">{{ getrolename(role) }}</div>
            <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="() => clearFilterType('role')"></i>
          </div>
        </div>
        <div class="clear-filters" :style="{ color: getPrimaryColor() }" @click="clearFilters">Clear Filters</div>
      </div>
    </div>
    <RecommendedFilterModal ref="recommendedFilterModal" :setCategory="setCategory" :answer="role" />

    <div>
      <div class="doctors-search-result">
        <div id="cards-section-top" class="card-section">
          <p class="text-left results" v-if="reviews && !loading">
            <span>{{ count }} {{ count <= 1 ? "Result" : "Results" }}</span>
          </p>
          <div class="dropdownOptions text-right" v-if="reviews && !loading">
            <a-dropdown :style="{ marginTop: '7px', cursor: 'pointer' }">
              <p class="sort-text cp">
                Show
                <span style="font-weight: 700">{{ sortKey === "Newest" ? "Newest First" : sortKey === "Recommend" ? "Most Recommended First" : "" }}</span>
                <font-awesome-icon size="lg" style="margin-left: 8px" :icon="['fas', 'angle-down']" />
              </p>
              <template #overlay>
                <a-menu @click="e => sortList(e.key)">
                  <a-menu-item key="Newest">Newest First</a-menu-item>
                  <a-menu-item key="Recommend">Most Recommended First</a-menu-item>
                  <!-- <a-menu-item key="Popular">Most Popular</a-menu-item> -->
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </div>
      </div>
      <div v-if="loading" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
      </div>
      <div class="row" v-if="reviews && !loading">
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-3">
          <RecommendCard v-for="review in reviews" :reviewData="review" :key="review" />
        </div>
      </div>
      <div v-if="!reviews && !loading" class="text-center">
        <p>No Results Found</p>
      </div>
    </div>
    <div
      v-if="this.count > 10 && !loading && reviews"
      :style="{
        padding: '30px',
        display: 'flex',
        justifyContent: 'center',
      }"
    >
      <a-pagination v-model="page" class="dovemed-custom-pagination" :total="this.count ? this.count : 0" show-less-items :pageSize="10" @change="getRecommendedUser" />
    </div>
  </div>
</template>

<script>
import RecommendedFilterModal from "../../Modals/RecommendedFilterModal.vue"
import RecommendCard from "../../home/Recommended/RecommendCard.vue"
import userRepository from "../../../repositories/userRepository"
export default {
  name: "Recommended",
  components: {
    RecommendedFilterModal,
    RecommendCard,
  },
  data() {
    return {
      role: undefined,
      page: 1,
      item: 10,
      searchbyname: undefined,
      sortKey: "Newest",
      count: 0,
      loading: false,
      reviews: [],
    }
  },
  mounted() {
    this.setVariablesFromQuery()
    this.getRecommendedUser()
  },
  watch: {
    role: {
      handler() {
        this.handlePathQuery("role")
      },
    },
    sortKey: {
      handler() {
        this.handlePathQuery("sortKey")
      },
    },
    page: {
      handler() {
        this.handlePathQuery("page")
      },
    },
  },
  methods: {
    setVariablesFromQuery() {
      Object.keys(this.$route.query).forEach(key => {
        if (this.$route.query[key]) {
          this[key] = this.$route.query[key]
        }
      })
    },
    handlePathQuery(v) {
      this.$router
        .replace({
          ...this.$route,
          query: {
            ...this.$route.query,
            [v]: this[v],
          },
        })
        .catch(e => {})
    },
    callDebounce: _.debounce(function () {
      this.handleSearchEnter()
    }, 500),
    setCategory(filter = "") {
      this.role = filter

      this.page = 1
      this.getRecommendedUser()
    },
    handleSearchEnter() {
      this.page = 1
      this.getRecommendedUser()
    },
    handleClearSearch() {
      this.searchbyname = ""
      this.page = 1
      this.getRecommendedUser()
    },
    getRecommendedUser(append) {
      this.loading = true
      this.searchbyname = this.searchbyname ? this.searchbyname.trim() : undefined
      this.handlePathQuery("searchbyname")
      window.scrollTo(0, 0)
      userRepository
        .getRecommendedUsers(this.currentCircle.id, this.page, this.item, this.sortKey, this.role, this.searchbyname)
        .then(res => {
          this.loading = false
          this.reviews = res.data.data.data

          this.count = res.data.data ? parseInt(res.data.data.paginator.total_count) : 0
        })
        .catch(err => {
          this.loading = false
        })
    },
    clearFilterType(type) {
      if (type === "role") {
        this.role = undefined
      }
      this.page = 1
      this.getRecommendedUser()
    },
    sortList(key) {
      this.sortKey = key
      this.page = 1
      this.getRecommendedUser()
      //this.getPeople();
    },
    clearFilters() {
      this.role = undefined
      this.getRecommendedUser()
    },
    handlefilter() {
      this.$refs.recommendedFilterModal.Show()
    },
    getrolename(role) {
      switch (role) {
        case "ohcp":
          return "Advanced Practice Providers"
          break

        case "doctor":
          return "Physicians"
          break

        case "hospital_administrator":
          return "Hospitals"
          break

        case "clinic_administrator":
          return "Clinics"
          break

        case "nfp_administrator":
          return "Non-For-Profits"
          break

        default:
          return role
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 427px) {
  .clear-filter {
    display: none !important;
  }
  .apply {
    margin-bottom: 0px !important;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #0f1734 !important;
    display: block !important;
  }
  .search-button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    max-width: 100% !important;
  }
  .search-container {
    flex-direction: column;
  }
}
.clear-filters {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  @media screen and (max-width: 700px) {
    margin-top: 16px;
    align-self: center;
  }
}

.top_filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  @media screen and (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.apply {
  display: none;
}
.search-container {
  display: flex;
  margin-top: 24px;
  gap: 24px;

  .search-input-state {
    background: none;
    border-left: 0 !important;
    height: 60px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;

    &:focus {
      outline: none;
    }
  }
}

.results {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
}
.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;
  padding: 0px 10px;

  input {
    border: none !important;
  }
}

.search-button {
  max-width: 60px;
  min-width: 60px;
  border-radius: 8px;
  border: none;
  height: 60px;
  background-color: #f1f5f9 !important;
  &:focus {
    outline: none;
  }
  .active-filter-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    align-self: flex-start;
    margin-top: 18px;
    margin-left: 5px;
    @media screen and (min-width: 701px) {
      top: 0;
      right: 0;
      position: absolute;
      margin-right: 10px;
      margin-top: 15px;
    }
  }
}

.card-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 56px;
}

.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: context-menu;
}

.filter-container {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.filter-text {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #0f1734;
  margin-left: 16px;
  @media screen and (min-width: 701px) {
    display: none;
  }
}
.appliedFilter {
  font-weight: 700;
  font-size: 14px;
  color: #647490;
  line-height: 24px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.filterTypeBox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 8px;
  background: #f1f5f9;
  border-radius: 6px;

  .filterTypeText {
    font-weight: 700;
    font-size: 14px;
    color: #0f1734;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/Recommended/Recommended.vue